import Builder from "./components/Builder"
import Properties from "./components/Properties"

let module = "checklist"

export default [
  {
    path: "checklist/properties",
    component: Properties,
    props: true,
    meta: { module: module + "-properties", permissions: ["checklisttemplate-access"] }
  },
  {
    path: "checklist/builder",
    component: Builder,
    props: true,
    meta: { module: module + "-forms", permissions: ["checklisttemplate-access"] }
  },
]
